import React, { useState, useEffect } from 'react'
import MaterialTable from 'material-table'
import { useTheme } from '@material-ui/core'
import DeleteBtn from 'components/Custom/DeleteBtn'
import { useAuthContext } from 'hooks/useAuthContext'
import { Checkbox } from '@material-ui/core';

const Grid = ({ columns, title, getRecords, selectedProject, component, deleteRecord, dynamicForm = false, paging = true, selection = { "display": false }, data = [], PassFail = false }) => {
    const theme = useTheme()
    const [updateDate, setUpdateDate] = useState(new Date())
    const [editable, setEditable] = useState({})
    const [action, setAction] = useState(null)
    const { role } = useAuthContext()
    const handleChange = (event) => {
        selection.callback(event, event.target.value)
    }

    // TODO: fix roles
    useEffect(() => {
        role && dynamicForm && !PassFail && setEditable(DeleteBtn(setUpdateDate, deleteRecord, selectedProject)) // delete
        role && role.check(component, 'read') && !dynamicForm && !PassFail && setAction(true)   // edit
    }, [role, selectedProject, updateDate, PassFail])

    return (
        <div>
            <MaterialTable
                key={updateDate}
                style={{ boxShadow: "0 0 0 0" }}
                options={{
                    headerStyle: {
                        backgroundColor: theme.palette.background.default,
                        color: theme.palette.text.primary,
                    },
                    paging: paging,
                    search: false
                }}
                padding="default"
                columns={columns = columns.map(col => {
                    return col
                }).filter(r => !r.hide)}
                title={title}
                data={data.length > 0 ? data : query =>
                    new Promise((resolve, reject) => {
                        const page = query.page
                        getRecords(query.page, query.pageSize, query.orderBy, query.orderDirection, { projectID: selectedProject }).then(r => {
                            resolve({
                                data: r.data,
                                page,
                                totalCount: r.count
                            })
                        })
                    })
                }
                editable={!PassFail && editable}
                actions={[
                    selection.display ? rowData => ({
                        tooltip: selection.tooltip,
                        icon: () => <Checkbox
                            defaultChecked={rowData.value === 'Show' ? true : false}
                            name={rowData.name}
                            inputProps={{ 'aria-label': 'secondary checkbox' }}
                            value={JSON.stringify(rowData)}
                            onChange={(event) => {
                                handleChange(event)
                            }}
                        />
                    }) : null
                ]}
            />
        </div>
    )
}

export default Grid